"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillableKetteGuard = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const baseFillableKetteValidation = {
    innenhoehe: (value) => Boolean(value && value.mm > 0),
    innenbreite: (value) => Boolean(value && value.mm > 0),
    aussenhoehe: (value) => Boolean(value && value.mm > 0),
    aussenbreite: (value) => Boolean(value && value.mm > 0),
};
const fillableDefaultKetteValidation = Object.assign(Object.assign({}, baseFillableKetteValidation), { minDistKlemmO: true, minDistKlemmU: true, minDistO: true, minDistU: true, rastPosDist: true, rastPosLeft: true });
const fillableEskinValidation = baseFillableKetteValidation;
const fillableTwisterbandValidation = baseFillableKetteValidation;
const fillableTwisterchainValidation = baseFillableKetteValidation;
const fillableTriflexValidation = Object.assign(Object.assign({}, baseFillableKetteValidation), { bi1: (value) => Boolean(value && value.mm > 0) });
const fillableRxRohrValidation = baseFillableKetteValidation;
const fillableRolEchainValidation = baseFillableKetteValidation;
/** Provide type guards for the different "useable" kinds. */
class FillableKetteGuard {
    static isFillable(kette) {
        if (!kette)
            return false;
        switch (kette.serieType) {
            case echain_shared_articles_1.KetteSerieType.default:
                return this.isFillableDefault(kette);
            case echain_shared_articles_1.KetteSerieType.eskin:
                return this.isFillableEskin(kette);
            case echain_shared_articles_1.KetteSerieType.twisterband:
                return this.isFillableTwisterband(kette);
            case echain_shared_articles_1.KetteSerieType.twisterchain:
                return this.isFillableTwisterchain(kette);
            case echain_shared_articles_1.KetteSerieType.trxe:
                return this.isFillableTrxe(kette);
            case echain_shared_articles_1.KetteSerieType.triflexR:
                return this.isFillableTriflex(kette);
            case echain_shared_articles_1.KetteSerieType.rxRohr:
                return this.isFillableRxRohr(kette);
            case echain_shared_articles_1.KetteSerieType.rolEchain:
                return this.isFillableRolEchain(kette);
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(kette.serieType);
        }
    }
    static isFillableDefault(kette) {
        return (kette === null || kette === void 0 ? void 0 : kette.serieType) === echain_shared_articles_1.KetteSerieType.default && echain_shared_modelling_1.UseableUtil.validate(kette, fillableDefaultKetteValidation);
    }
    static isFillableEskin(kette) {
        return (kette === null || kette === void 0 ? void 0 : kette.serieType) === echain_shared_articles_1.KetteSerieType.eskin && echain_shared_modelling_1.UseableUtil.validate(kette, fillableEskinValidation);
    }
    static isFillableTwisterband(kette) {
        return ((kette === null || kette === void 0 ? void 0 : kette.serieType) === echain_shared_articles_1.KetteSerieType.twisterband && echain_shared_modelling_1.UseableUtil.validate(kette, fillableTwisterbandValidation));
    }
    static isFillableTwisterchain(kette) {
        return ((kette === null || kette === void 0 ? void 0 : kette.serieType) === echain_shared_articles_1.KetteSerieType.twisterchain && echain_shared_modelling_1.UseableUtil.validate(kette, fillableTwisterchainValidation));
    }
    static isFillableTriflex(kette) {
        return (kette === null || kette === void 0 ? void 0 : kette.serieType) === echain_shared_articles_1.KetteSerieType.triflexR && echain_shared_modelling_1.UseableUtil.validate(kette, fillableTriflexValidation);
    }
    static isFillableTrxe(kette) {
        return (kette === null || kette === void 0 ? void 0 : kette.serieType) === echain_shared_articles_1.KetteSerieType.trxe && echain_shared_modelling_1.UseableUtil.validate(kette, fillableTriflexValidation);
    }
    static isFillableRxRohr(kette) {
        return (kette === null || kette === void 0 ? void 0 : kette.serieType) === echain_shared_articles_1.KetteSerieType.rxRohr && echain_shared_modelling_1.UseableUtil.validate(kette, fillableRxRohrValidation);
    }
    static isFillableRolEchain(kette) {
        return (kette === null || kette === void 0 ? void 0 : kette.serieType) === echain_shared_articles_1.KetteSerieType.rolEchain && echain_shared_modelling_1.UseableUtil.validate(kette, fillableRolEchainValidation);
    }
}
exports.FillableKetteGuard = FillableKetteGuard;
//# sourceMappingURL=FillableKette.js.map